import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/common/ProtectedRoute";
import Layout from "./components/layout/Layout";
import LoginPage from "./pages/LoginPage";
import LoginCallback from "./pages/LoginCallback";
import DashboardPage from "./pages/DashboardPage";
import SolutionGroupPage from "./pages/SolutionGroupPage";
import SolutionPage from "./pages/SolutionPage";
import IndicatorGroupPage from "./pages/IndicatorGroupPage";
import IndicatorPage from "./pages/IndicatorPage";
import IndicatorDetailPage from "./pages/IndicatorDetailPage";
import CategoryPage from "./pages/CategoryPage";
import QuestionPage from "./pages/QuestionPage";
import RiskRulePage from "./pages/RiskRulePage";
import AssessTypeGroupPage from "./pages/AssessTypeGroupPage";
import AssessTypePage from "./pages/AssessTypePage";
import AssessTypeDetailPage from "./pages/AssessTypeDetailPage";
import ProCoursePage from "./pages/ProCoursePage";
import CommunityReportPage from "./pages/CommunityReportPage";
import CommunityPostPage from "./pages/CommunityPostPage";
import CommunityCommentPage from "./pages/CommunityCommentPage";
import CommunityCustomerPage from "./pages/CommunityCustomerPage";
import AssessmentReportPage from "./pages/AssessmentReportPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/callback" element={<LoginCallback />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/solution-groups" element={<SolutionGroupPage />} />
            <Route path="/solutions" element={<SolutionPage />} />
            <Route path="/indicator-groups" element={<IndicatorGroupPage />} />
            <Route path="/indicators" element={<IndicatorPage />} />
            <Route path="/indicators/:id" element={<IndicatorDetailPage />} />
            <Route path="/categories" element={<CategoryPage />} />
            <Route path="/questions" element={<QuestionPage />} />
            <Route path="/pro-courses" element={<ProCoursePage />} />
            <Route path="/pro-courses/:qstId" element={<ProCoursePage />} />
            <Route path="/risk-rules" element={<RiskRulePage />} />
            <Route path="/assess-type-groups" element={<AssessTypeGroupPage />} />
            <Route path="/assess-types" element={<AssessTypePage />} />
            <Route path="/assess-types/:id" element={<AssessTypeDetailPage />} />
            <Route path="/assessment-reports" element={<AssessmentReportPage />} />
            <Route path="/community/reports" element={<CommunityReportPage />} />
            <Route path="/community/posts" element={<CommunityPostPage />} />
            <Route path="/community/comments" element={<CommunityCommentPage />} />
            <Route path="/community/customers" element={<CommunityCustomerPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
